import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

export interface TextboxDialogData {
  pretext?: string;
  posttext?: string;
  text: string;
  rows?: number;
  cols?: number;
  writable?: boolean;
}

@Component({
  selector: 'prox-textbox-dialog',
  template: `
  <div>
    <div class="text-l mb-3">{{ data.pretext }}</div>
    <textarea [readonly]="readonly" [rows]="rows" [cols]="cols" id="textbox-dialog-text" [(ngModel)]="data.text"></textarea>
    <div class="text-l my-3">{{ data.posttext}}</div>
    <div class="text-right mt-3">
      <button (click)="close()" pButton type="button" icon="pi pi-check" label="Ok"
            class="p-button-raised p-button-primary"></button>
    </div>

  </div>
  `,
  standalone: false
})
export class TextboxDialogComponent {

  data: TextboxDialogData;
  rows: number;
  cols: number;
  readonly = true;

  constructor(dialogConfig: DynamicDialogConfig<TextboxDialogData>, private ref: DynamicDialogRef) {
    this.data = dialogConfig.data || { text: 'no data' };
    this.rows = this.data.rows || 7;
    this.cols = this.data.cols || 80;
    this.readonly = !this.data.writable;
  }

  close() {
    this.ref.close(this.data.text);
  }

}
